import { get } from 'lodash/fp';

export const getPhpSessionId = get(['extra', 'phpSessionId']);
